import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import Modal from '@mui/material/Modal';
import { Button } from '@mui/material';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

const PREFIX = 'ModalDialog';

const classes = {
  modal: `${PREFIX}-modal`,
  paper: `${PREFIX}-paper`,
  bottomDiv: `${PREFIX}-bottomDiv`,
  divider1: `${PREFIX}-divider1`,
  divider2: `${PREFIX}-divider2`,
  space: `${PREFIX}-space`,
};

const StyledModal = styled(Modal)(({ theme }) => ({
  [`&.${classes.modal}`]: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    overflow: 'scroll',
  },

  [`& .${classes.paper}`]: {
    boxShadow: theme.shadows[5],
    margin: 'auto',
    padding: theme.spacing(2, 4, 2),
  },

  [`& .${classes.bottomDiv}`]: {
    textAlign: 'center',
  },

  [`& .${classes.divider1}`]: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },

  [`& .${classes.divider2}`]: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },

  [`& .${classes.space}`]: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

const ModalDialog = props => {
  const {
    okButtonText,
    title,
    children,
    handleOk,
    handleClose,
    size,
    noButtons,
    noDivider,
    open,
    noOkButton,
    noCloseButton,
  } = props;

  let showStatus = open;

  let width = 800;
  if (size === 'xs') width = 400;
  if (size === 'sm') width = 600;
  if (size === 'md') width = 800;
  if (size === 'lg') width = 1220;
  if (size === 'xl') width = 1400;

  if (typeof open !== 'boolean') {
    showStatus = true;
  }

  if (!showStatus) {
    return null;
  }

  return (
    <StyledModal open={showStatus} className={classes.modal} onClose={() => handleClose && handleClose()}>
      <Paper className={classes.paper} style={{ width: width }}>
        <Typography variant='h3'>{title}</Typography>
        {noDivider || <Divider className={classes.divider1} />}

        {children}

        {noDivider || <Divider className={classes.divider2} />}
        <div className={classes.bottomDiv}>
          {handleClose && !noButtons && !noCloseButton && (
            <Button color='secondary' variant='contained' className={classes.space} onClick={() => handleClose()}>
              Отменить
            </Button>
          )}
          {handleOk && !noButtons && !noOkButton && (
            <Button color='primary' variant='contained' className={classes.space} onClick={() => handleOk()}>
              {okButtonText || 'Ok'}
            </Button>
          )}
        </div>
      </Paper>
    </StyledModal>
  );
};

ModalDialog.propTypes = {
  title: PropTypes.string,
  okButtonText: PropTypes.string,
  handleOk: PropTypes.func,
  handleClose: PropTypes.func,
};

export default ModalDialog;
